"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var shouldSpeakIncomingActivity = _ref.shouldSpeakIncomingActivity;
  return shouldSpeakIncomingActivity;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzaG91bGRTcGVha0luY29taW5nQWN0aXZpdHkiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VsZWN0b3JzL3Nob3VsZFNwZWFrSW5jb21pbmdBY3Rpdml0eS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IFJlZHV4U3RhdGUgfSBmcm9tICcuLi90eXBlcy9pbnRlcm5hbC9SZWR1eFN0YXRlJztcblxuZXhwb3J0IGRlZmF1bHQgKHsgc2hvdWxkU3BlYWtJbmNvbWluZ0FjdGl2aXR5IH06IFJlZHV4U3RhdGUpOiBib29sZWFuID0+IHNob3VsZFNwZWFrSW5jb21pbmdBY3Rpdml0eTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztlQUVlO0VBQUEsSUFBR0EsMkJBQUgsUUFBR0EsMkJBQUg7RUFBQSxPQUEwREEsMkJBQTFEO0FBQUEsQyJ9